<template>
  <div class="box two-list">
    <details-head img="./img/bj4.png" title="通知公告" remarks="Notice" />
    <TopBreadcrumb :data="[{ label: '信息动态' }, { label: '通知公告' }]" />
    <div class="con" v-loading="loading">
      <!-- 搜索框 -->
      <Search :title.sync="searchValue" :year.sync="yearSelect" @select="select()" />
      <div class="list">
        <div class="item" v-for="(item, i) in list" :key="i" @click="$router.push({ name: 'NoticeSee', params:{id:item.id} })">
          <div class="time">{{new Date(item.createDate).formatCode('YYYY.MM.DD')}}</div>
          <div class="bottom">
            <img src="@/assets/icon/new.png" alt="" />
            <div>
              <div class="title">{{$textyc(item.title, 30)}}</div>
              <div class="remarks" v-text="$textyc($html2text(item.content), 85)"></div>
            </div>
          </div>
        </div>
        <div class="kong" v-if="!list || list.length == 0">数据为空</div>
      </div>

      <div class="moer" v-if="list.length < total">
        <div @click="onAddList">加载更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import { pageQuery } from "@/api/notice.js";
import Search from "../comp/Search.vue";
export default {
  name: "Home",
  components: { DetailsHead, TopBreadcrumb, Search },
  data() {
    return {
      yearSelect: "",
      searchValue: "",

      total: 1,
      page: 1,
      size: 10,

      list: [],

      loading: false,
    };
  },
  mounted() {
    this.select();
  },
  methods: {
    onAddList() {
      this.select(true);
    },

    select(isAdd) {
      this.loading = true;
      if (!isAdd) this.page = 1;
      else this.page++;
      pageQuery({
        page: this.page,
        size: this.size,
        date: this.yearSelect,
        title: this.searchValue,
      })
        .then((res) => {
          const { data } = res;
          this.total = data.total;
          if (!isAdd) this.list = [];
          data.records.forEach((item) => {
            this.list.push(item);
          });
          console.log(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
 
<style lang="less" scoped>
@import url("../comp/css/two-list.less");
@import url("../comp/css/load-moer.less");
.con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
}
</style>